import React from 'react';
import './Page.css';
import usePageTitle from '../hooks/usePageTitle';

function Store() {
  usePageTitle('Lodge Store');
  return (
    <div className="page-container">
      <div className="page-hero store-hero" style={{ backgroundImage: 'url(/brotherhoodDGM.jpg)', backgroundPosition: 'center top' }}>
        <h1>Lodge Store</h1>
        <p>Support Muncy Lodge No. 299</p>
      </div>

      <div className="page-content">
        <section className="content-section">
          <h2>Welcome to Our Store</h2>
          <p>
            Support Muncy Lodge No. 299 by purchasing lodge merchandise and making donations. 
            All proceeds support our charitable activities and lodge operations.
          </p>
        </section>

        <section className="content-section">
          <h2>Lodge Merchandise</h2>
          <div className="store-grid">
            <div className="store-item">
              <div className="item-placeholder">
                <span>Product Image</span>
              </div>
              <h3>Lodge Apparel</h3>
              <p>T-shirts, polo shirts, and hats featuring the Muncy Lodge logo</p>
              <p className="item-price">Starting at $20</p>
              <button className="cta-button secondary">Coming Soon</button>
            </div>

            <div className="store-item">
              <div className="item-placeholder">
                <span>Product Image</span>
              </div>
              <h3>Masonic Gifts</h3>
              <p>Rings, cufflinks, and other Masonic jewelry and accessories</p>
              <p className="item-price">Varies</p>
              <button className="cta-button secondary">Coming Soon</button>
            </div>

            <div className="store-item">
              <div className="item-placeholder">
                <span>Product Image</span>
              </div>
              <h3>Event Tickets</h3>
              <p>Purchase tickets for upcoming lodge events and fundraisers</p>
              <p className="item-price">Varies by Event</p>
              <button className="cta-button secondary">Coming Soon</button>
            </div>
          </div>
        </section>

        {/* HIDDEN: Fundraiser Raffle section — uncomment when approved
        <section className="content-section">
          <h2>Current Fundraiser Raffle</h2>
          <div className="raffle-feature">
            <div className="raffle-card">
              <h3>🦆 Duck Blind Raffle</h3>
              <p>
                Win a premium duck blind perfect for your next hunting season! This professionally built 
                blind features weatherproof construction, comfortable seating, and excellent concealment. 
                Perfect for waterfowl hunters of all experience levels.
              </p>
              <div className="raffle-details">
                <p><strong>Ticket Price:</strong> $10 each or 3 for $25</p>
                <p><strong>Drawing Date:</strong> TBD</p>
                <p><strong>Prize Value:</strong> $500+</p>
              </div>
              <button className="cta-button primary">Buy Raffle Tickets</button>
              <p className="raffle-note">
                All proceeds support Muncy Lodge charitable activities and community programs.
              </p>
            </div>
          </div>
        </section>
        END HIDDEN */}

        <section className="content-section">
          <h2>Pay Membership Dues</h2>
          <p>
            Current members can pay their annual membership dues online through the Grand View portal. 
            Simply log in with your member credentials to view your account and make a payment.
          </p>
          <a 
            href="https://portal.pamasons.org/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="cta-button primary"
          >
            Grand View Login →
          </a>
          <p className="info-note" style={{ marginTop: '1rem' }}>
            <strong>Note:</strong> You must be a registered member to access the Grand View portal. 
            If you need assistance with your login, please <a href="/contact">contact our Secretary</a>.
          </p>
        </section>

        <section className="content-section donation-section">
          <h2>Make a Donation</h2>
          <p>
            Your generous donations help us continue our charitable work in the community. 
            As a 501(c)(10) organization, your contributions support local families, youth programs, 
            and community initiatives.
          </p>
          
          <div className="donation-options">
            <div className="donation-card">
              <h3>One-Time Donation</h3>
              <p>Make a single donation to support our charitable activities</p>
              <button className="cta-button secondary" disabled>Coming Soon</button>
            </div>
            
            <div className="donation-card">
              <h3>Monthly Support</h3>
              <p>Become a monthly supporter and make a lasting impact</p>
              <button className="cta-button secondary" disabled>Coming Soon</button>
            </div>
          </div>

          {/* HIDDEN: Zeffy info — uncomment when donation platform is set up
          <div className="zeffy-info">
            <p className="info-note">
              <strong>Note:</strong> Our store and donation platform is powered by Zeffy, 
              a 100% free platform for nonprofits. This means 100% of your donation goes 
              directly to supporting our charitable work.
            </p>
          </div>
          END HIDDEN */}
        </section>

        <section className="content-section">
          <h2>Questions?</h2>
          <p>
            If you have questions about purchasing items or making a donation, please contact our Secretary.
          </p>
          <a href="/contact" className="cta-button secondary">Contact Us</a>
        </section>
      </div>
    </div>
  );
}

export default Store;
